import { useAppStore } from '@/stores/appStore'
import { useAuthStore } from '@/stores/authStore'
import { Cookies } from 'quasar'

export const myRequest = async (method: 'GET' | 'POST' | 'DELETE', path: string, body?: object) => {
  const appStore = useAppStore()
  const options: {
    method: 'GET' | 'POST' | 'DELETE'
    credentials: 'include'
    headers?: { 'Content-Type': 'application/json' }
    body?: string
  } = { method, credentials: 'include' }
  if (method === 'POST' && body) {
    options.headers = { 'Content-Type': 'application/json' }
    options.body = JSON.stringify(body)
  }
  if (!path.startsWith('/')) path = `/${path}`
  const response = await fetch(`${import.meta.env.VITE_API_URL}${path}`, options)
  if (response.status === 401) {
    if (Cookies.get('meetingHero') || useAuthStore().isAuthenticated) {
      appStore.errorType = 'Auth'
      appStore.showDialog = true
    }
  } else if (!response.ok) {
    appStore.errorType = 'Generic'
    appStore.showDialog = true
  }
  const contentType = response.headers.get('content-type')
  let result = null
  if (contentType?.includes('application/json')) {
    result = await response.json()
  } else {
    result = await response.text()
  }
  if (!response.ok) appStore.errorMessage = result?.message || result?.error || result
  console.log(method, response.status, path, result)
  return result
}
